module.exports = __webpack_public_path__ + "static/media/su_importancia_dentro_del_gremio_de_farmacia.c3eb0a6d.md";